<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{$t('Cash-Report')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search" :label="$t('Search')" append-icon="search">
              </v-text-field>
              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> Mail Gönder
</v-btn>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>



            </v-toolbar>
          </v-flex>
<!-- MAIL GÖNDER DIALOG -->
<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

          <v-container fluid>
            <v-layout wrap="">

              <v-flex xs12 sm6 md3 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">info</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Turnover') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ devir | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Opening-Turnover') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ acilisDevir | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Cash-Turnover') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ kasaDevir | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{ $t('Turnover') }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md3 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">info</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Credit') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ oncekiDonemAlacak | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{$t('Balance')}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ oncekiDonemBakiye | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Debit') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ oncekiDonemBorc | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{ $t('Previous-Period') }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md3 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">info</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Credit') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamAlacak | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Debit') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamBorc | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{$t('Total')}} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md3 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">info</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Credit') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ donemAlacak | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Debit') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ donemBorc | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{ $t('Period-v2') }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>



            </v-layout>
          </v-container>

          <v-container fluid>

            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>

                <v-layout row wrap>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date"
                      v-model="date"></tarihcomp>

                  </v-flex>
                  <v-flex xs12 sm6 md2>

                    <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date2"
                      v-model="date2"></tarihcomp>


                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <div v-if="load1">
                        <v-btn color="info" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>
                      </div>

                      <v-badge color="white" :overlap="true">
                        <template v-slot:badge>
                          <v-icon v-if="filtrevarmi" large color="green">
                            check_circle_outline </v-icon>
                        </template>

                        <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                          @click="filtrele()" color="info" fab dark>
                          <v-icon>filter_list</v-icon>
                        </v-btn>
                        <v-tooltip bottom="" :activator="el" v-model="tooltip">
                          <span>{{$t('Add-Search-Filter')}}</span>
                        </v-tooltip>



                      </v-badge>
                    </v-layout>
                  </v-flex>


                  <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
                    <v-card color="grey lighten-5">

                      <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-layout row="" wrap="">



                          <v-flex pa-1 xs12 sm12 md12>
                            <v-card class="white--text">
                              <v-card color="grey lighten-5" flat="">
                                <v-card-actions>
                                  <v-layout justify-space-between column>
                                    <v-select :items="doviztipi" :label="$t('Currency-Type')" item-text="DovizAdi" hide-details=""
                                      v-model="KasaRapor.Doviz.DovizKod" item-value="DovizKod" max-height="400">
                                    </v-select>
                                    <v-select :items="evraktipi" hide-details="" :label="$t('Document-Type-v2')" multiple=""
                                      v-model="secilenevraklar" item-text="Title" clearable item-value="Evrakkod"
                                      max-height="400"></v-select>

                                  </v-layout>
                                </v-card-actions>
                              </v-card>
                            </v-card>
                          </v-flex>


                          <br>
                          <v-flex pa-1 xs12 sm12 md12>
                            <v-card flat="" color="#9E9E9E">
                              <v-card-title>
                                <span class="subheading white--text font-weight-medium "> {{ $t('Options-v2') }}</span>
                              </v-card-title>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm12 md6>
                            <v-layout justify-space-between column>
                              <v-radio-group :label="$t('Order-v2')" v-model="KasaRapor.Siralama" column>
                                <v-radio checked="" :label="$t('Accound-Code')" value='0'> </v-radio>
                                <v-radio :label="$t('Date')" value='1'></v-radio>
                                <v-radio :label="$t('Currency-Type')" value="2"></v-radio>
                              </v-radio-group>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-layout justify-space-between column>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                              <v-checkbox v-model="KasaRapor.DovizliRapor" :label="$t('Foreign-Currency-Report')" hide-details=""></v-checkbox>
                            </v-layout>
                          </v-flex>

                        </v-layout>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                        <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-flex xs12 sm12>
                    <v-card flat>
                      <v-card-title>
                        <v-spacer></v-spacer>

                      </v-card-title>
                      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                        :search="search">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                        <template slot="items" slot-scope="props">
                          <td class="text-xs-left">{{ props.item.Date }}</td>
                          <td class="text-xs-left">{{ props.item.Current}} - {{ props.item.CurrentTitle}}</td>
                          <td class="text-xs-left">{{ props.item.DocumentType }}</td>
                          <td class="text-xs-left">{{ props.item.DocumentNumber}}</td>
                          <td class="text-xs-left">{{ props.item.Explanation}}</td>
                          <td class="text-xs-right">{{ props.item.Debt | moneyformat }}</td>
                          <td class="text-xs-right">{{ props.item.Credit | moneyformat }}</td>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          Your search for "{{ search }}" found no results.
                        </v-alert>
                      </v-data-table>
                    </v-card>
                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                      :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                      v-model="snackbar">
                      {{ text1 }}
                      <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                    </v-snackbar>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>
          </v-container>



        </v-layout>
      </v-card>
    </v-app>

  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from "@/components/app/customcomp/tarihim"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  export default {
    data() {
      return {
        mailDialog: false,
mailValid: false,
mailLoading: false,
mailPayload: {
  To: "",
  AgencyName: "",
  DocType: "Kasa Raporu - Cash Report",
  AgentFullName: "",
  CustomBody: ""
},
rules: {
  required: v => !!v || 'Zorunlu alan',
  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
},
        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        headers: [{
            text: this.$t('Date'),
            value: 'Date'
          },
          {
            text: this.$t('Currentcode_label'),
            value: 'Current'
          },
          {
            text: this.$t('Document-Type'),
            value: 'DocumentType'
          },
          {
            text: this.$t('Document-No'),
            value: 'DocumentNumber'
          },
          {
            text: this.$t('Description'),
            value: 'Explanation'
          },
          {
            text: this.$t('Debit'),
            value: 'Debt',
            align: 'right'
          },
          {
            text: this.$t('Credit'),
            value: 'Credit',
            align: 'right'
          }
        ],
        KasaRapor: {

          SirketKodu: '',
          BaslangicTarih: '',
          BitisTarih: '',
          Doviz: {
            DovizKod: ''
          },
          Evraklar: [],
          Siralama: '0',
          DovizliRapor:false


        },
        secilenevraklar: [],
        tumsirketler: '',
        devir: 0,
        acilisDevir: 0,
        kasaDevir: 0,
        oncekiDonemAlacak: 0,
        oncekiDonemBakiye: 0,
        oncekiDonemBorc: 0,
        toplamAlacak: 0,
        toplamBorc: 0,
        donemAlacak: 0,
        donemBorc: 0,
        StartDate: null,
        EndDate: null,


        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        statecari: [],
        searchcari: '',

        evraktipi: [],
        doviztipi: [],
        anahesap: [],
        valid: true,


        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        progress: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
        search: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      yetkidialog
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        this.progress = true
        this.date = helpers.getDateNow()
        this.date2 = helpers.getDateNow()
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
       this.PB=credentials.ParaBirimi;
        var Evrak1 = [{
          Evrakkod: null,
          BA: null,
          Aciklama: null,
          Cari: null,
        }]
        var Evraklar = []
        Evraklar.push(Evrak1)

        var params = {
          SirketKodu: credentials.SirketKodu,
          BaslangicTarih: this.date,
          BitisTarih: this.date2,
          Doviz: {
            DovizKod: null
          },
          Evraklar: Evraklar
        }
        this.$http.post(auth.API_URL + 'api/Report/CaseReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body.List
          this.devir = response.body.Devir
          this.acilisDevir = response.body.AcilisDevir
          this.kasaDevir = response.body.KasaDevir
          this.oncekiDonemAlacak = response.body.OncekiDonemAlacak
          this.oncekiDonemBakiye = response.body.OncekiDonemBakiye
          this.oncekiDonemBorc = response.body.OncekiDonemBorc
          this.toplamAlacak = response.body.ToplamAlacak
          this.toplamBorc = response.body.ToplamBorc
          this.donemAlacak = response.body.DonemAlacak
          this.donemBorc = response.body.DonemBorc

          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load = false
            this.load1 = true

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true

          }
        })


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }

    },
    watch: {

    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
    getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      openMailDialog,
      closeMailDialog,
      sendMail
    }
  }

  function openMailDialog() {
  if (!this.mailPayload) this.mailPayload = {};
  this.mailPayload.DocType = "Kasa Raporu - Cash Report";
  if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {
    this.$refs.mailForm.resetValidation();
  }
  this.mailDialog = true;
}

function closeMailDialog() {
  this.mailDialog = false;
}

function sendMail() {
  if (!(this.$refs && this.$refs.mailForm && this.$refs.mailForm.validate && this.$refs.mailForm.validate())) return;
  if (!(this.$refs && this.$refs.formtarih && this.$refs.formtarih.validate && this.$refs.formtarih.validate())) return;
  if (!this.date || !this.date2) {
    this.text1 = this.$t('Please-select-a-date');
    this.snackbar = true;
    return;
  }
  var credentialsRaw = window.localStorage.getItem('credentials');
  var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};
  var companyCode = this.tumsirketler === true ? '0' : (credentials && credentials.SirketKodu ? credentials.SirketKodu : null);
  var R = this.KasaRapor || {};
  var inputObj = {
    SirketKodu: companyCode,
    BaslangicTarih: this.date,
    BitisTarih: this.date2,
    Doviz: { DovizKod: R.Doviz && R.Doviz.DovizKod ? R.Doviz.DovizKod : "" },
    Evraklar: Array.isArray(R.Evraklar) ? R.Evraklar : [],
    Siralama: R.Siralama ? R.Siralama : "0",
    DovizliRapor: !!R.DovizliRapor
  };
  var mp = this.mailPayload || {};
  var fallbackDocType = "Kasa Raporu - Cash Report";
  var mailObj = {
    To: mp.To ? mp.To : "",
    AgencyName: mp.AgencyName ? mp.AgencyName : "",
    DocType: mp.DocType ? mp.DocType : fallbackDocType,
    AgentFullName: mp.AgentFullName ? mp.AgentFullName : "",
    CustomBody: mp.CustomBody ? mp.CustomBody : ""
  };
  var payload = { Input: inputObj, Mail: mailObj };
  this.mailLoading = true;
  var endpoint = auth.API_URL + 'api/Report/MailGonderCashReportExcel';
  this.$http.post(endpoint, payload, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } })
  .then(() => {
    this.mailLoading = false;
    this.mailDialog = false;
    this.text1 = this.$t ? this.$t('Email-sent') : 'Mail gönderildi.';
    this.snackbar = true;
  }, (err) => {
    this.mailLoading = false;
    var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};
    var msg = (body && (body.Message || body.message)) || err.statusText || (this.$t ? this.$t('Email-send-failed') : 'Mail gönderilemedi.');
    this.text1 = msg;
    this.snackbar = true;
  });
}



  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }


    // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
    //   headers: {
    //     'Authorization': 'Bearer ' + auth.getAuthHeader()
    //   }
    // }).then((response) => {
    //   this.Referans = response.body
    // }, (response) => {
    //   if (response.status === 0) {
    //     this.text1 = 'Service Unavailable'
    //     this.snackbar = true
    //   } else {
    //     this.text1 = 'Service Unavailable'
    //     this.snackbar = true
    //   }
    // })

    this.$http.post(auth.API_URL + 'api/currency/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {

      } else {

      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {

      } else {

      }
    })

  }


  function filtrekayit() {
    this.filtrevarmi = true
    this.getList();
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false

  }

  function getList() {


    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        this.devir = 0
        this.acilisDevir = 0
        this.kasaDevir = 0
        this.oncekiDonemAlacak = 0
        this.oncekiDonemBakiye = 0
        this.oncekiDonemBorc = 0
        this.toplamAlacak = 0
        this.toplamBorc = 0
        this.donemAlacak = 0
        this.donemBorc = 0

        this.progress = true
        this.load1 = false



        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var Evraklar1 = []
        if (this.secilenevraklar.length > 0) {
          Object.keys(this.secilenevraklar).forEach(key => {
            var evrak = {
              Evrakkod: this.secilenevraklar[key]
            }
            Evraklar1.push(evrak)
          });
        }

        this.KasaRapor.Evraklar = Evraklar1


        if (this.tumsirketler === true) {
          this.KasaRapor.SirketKodu = '0'
        } else {
          this.KasaRapor.SirketKodu = credentials.SirketKodu
        }
        this.KasaRapor.BaslangicTarih = this.date
        this.KasaRapor.BitisTarih = this.date2

        var params = this.KasaRapor


        this.$http.post(auth.API_URL + 'api/Report/CaseReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body.List
          this.devir = response.body.Devir
          this.acilisDevir = response.body.AcilisDevir
          this.kasaDevir = response.body.KasaDevir
          this.oncekiDonemAlacak = response.body.OncekiDonemAlacak
          this.oncekiDonemBakiye = response.body.OncekiDonemBakiye
          this.oncekiDonemBorc = response.body.OncekiDonemBorc
          this.toplamAlacak = response.body.ToplamAlacak
          this.toplamBorc = response.body.ToplamBorc
          this.donemAlacak = response.body.DonemAlacak
          this.donemBorc = response.body.DonemBorc
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true

          }
        })

      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }


  }


  function getListHtml() {
    this.devir = 0
    this.acilisDevir = 0
    this.kasaDevir = 0
    this.oncekiDonemAlacak = 0
    this.oncekiDonemBakiye = 0
    this.oncekiDonemBorc = 0
    this.toplamAlacak = 0
    this.toplamBorc = 0
    this.donemAlacak = 0
    this.donemBorc = 0

    this.progress = true
    this.load1 = false



    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var lang = localStorage.getItem('lang')
    var Evraklar1 = []
    if (this.secilenevraklar.length > 0) {
      Object.keys(this.secilenevraklar).forEach(key => {
        var evrak = {
          Evrakkod: this.secilenevraklar[key]
        }
        Evraklar1.push(evrak)
      });
    }

    this.KasaRapor.Evraklar = Evraklar1


    if (this.tumsirketler === true) {
      this.KasaRapor.SirketKodu = '0'
    } else {
      this.KasaRapor.SirketKodu = credentials.SirketKodu
    }
    this.KasaRapor.BaslangicTarih = this.date
    this.KasaRapor.BitisTarih = this.date2

    var params = this.KasaRapor


    this.$http
      .post(auth.API_URL + "api/Report/CaseReportHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        if (lang=='en')
          {
            
            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> KASA RAPORU </title>','<title> CASH REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>KASA RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>CASH REPORT</font>")

            
             response.bodyText=bodyhtml;
             
          }
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.bodyText], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.$t('kasaraporu') + ".html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true

        }
      })
  }

  function getListExcel() {
    this.devir = 0
    this.acilisDevir = 0
    this.kasaDevir = 0
    this.oncekiDonemAlacak = 0
    this.oncekiDonemBakiye = 0
    this.oncekiDonemBorc = 0
    this.toplamAlacak = 0
    this.toplamBorc = 0
    this.donemAlacak = 0
    this.donemBorc = 0

    this.progress = true
    this.load1 = false



    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var Evraklar1 = []
    if (this.secilenevraklar.length > 0) {
      Object.keys(this.secilenevraklar).forEach(key => {
        var evrak = {
          Evrakkod: this.secilenevraklar[key]
        }
        Evraklar1.push(evrak)
      });
    }

    this.KasaRapor.Evraklar = Evraklar1


    if (this.tumsirketler === true) {
      this.KasaRapor.SirketKodu = '0'
    } else {
      this.KasaRapor.SirketKodu = credentials.SirketKodu
    }
    this.KasaRapor.BaslangicTarih = this.date
    this.KasaRapor.BitisTarih = this.date2

    var params = this.KasaRapor


    this.$http
      .post(auth.API_URL + "api/Report/CaseReportExcel", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.$t('kasaraporu') + ".xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true

        }
      })
  }

  function beforeMount() {

  }
</script>


<style>
</style>